import React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';

import st from './EmptyCard.module.sass';

/**
 * @deprecated Этот компонент устарел. Используйте @vlabs/monokit/shared/ui/empty-card.
 * Компонент будет удалён после редизайна страницы Архива событий.
 */
export function EmptyCard({
  className,
  text,
  dataTip,
  icon,
  ...props
}) {
  return (
    <div
      className={cn(st.Root, className)}
      {...props}
    >
      {icon}
      <span className={st.Text}>
        {text}

        {!!dataTip && (
          <Tooltip
            className={st.Tooltip}
            tooltipContent={dataTip}
            tooltipProps={{ effect: 'solid' }}
          >
            <InfoCircleIcon className={st.Tooltip_icon} />
          </Tooltip>
        )}
      </span>
    </div>
  );
}

EmptyCard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  dataTip: PropTypes.string,
  icon: PropTypes.element,
};
EmptyCard.defaultProps = {
  className: undefined,
  text: undefined,
  dataTip: undefined,
  icon: undefined,
};
